<template>
  <el-table-column
    prop="amount"
    sortable="custom"
    label="Összeg"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.amount | currency }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'amount',
  };
</script>
